import { ASTNode, print } from "graphql";

import { GET_REVIEW_REPORT_DATA_COUNT, GET_REVIEW_REPORT_DISTRIBUTION_DATA } from "../../hooks/useQuery";

import { fetchData } from "./utils";

export const getRawReviewReportData = (variables) =>
	fetchData(
		`
            query GetReviewReportData(
                $questionGroupingSessionID: ObjectID!
                $columns: JSON
                $pageNumber: String
                $pageSize: String
                $filters: [[FilterItem]]
                $sorts: [ReviewReportsSort]
                $summarizeBy: [ReviewReportsSummarizeBy]
                $aggregationOperations: [ReviewReportsAggregationOperation]
            ) {
                reviewReportsVisualization(
                    questionGroupingSessionID: $questionGroupingSessionID
                    columns: $columns
                    filters: $filters
                    pageNumber: $pageNumber
                    pageSize: $pageSize
                    sorts: $sorts
                    summarizeBy: $summarizeBy
                    aggregationOperations: $aggregationOperations
                )
            }
        `,
		variables
	);

export const getGridDataCount = (variables) => fetchData(print(GET_REVIEW_REPORT_DATA_COUNT as ASTNode), variables);

export const getReviewReportDistributionData = (variables) =>
	fetchData(print(GET_REVIEW_REPORT_DISTRIBUTION_DATA as ASTNode), variables);
